export default __webpack_public_path__ + "static/media/Locacoes.fca76fef.svg";